var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconawesomeSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.815,
    height: 20.812,
    viewBox: "0 0 20.815 20.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-search",
    "data-name": "Icon awesome-search",
    d: "M20.529,18l-4.053-4.053a.975.975,0,0,0-.691-.285h-.663a8.451,8.451,0,1,0-1.463,1.463v.663a.975.975,0,0,0,.285.691L18,20.529a.972.972,0,0,0,1.378,0l1.15-1.15a.98.98,0,0,0,0-1.382ZM8.455,13.659a5.2,5.2,0,1,1,5.2-5.2A5.2,5.2,0,0,1,8.455,13.659Z",
    transform: "translate(20.815) rotate(90)",
    fill: "#335e76"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeSearch);
export default __webpack_public_path__ + "static/media/Icon awesome-search.89ae9f5d8e57de165ad5ab32f149399a.svg";
export { ForwardRef as ReactComponent };